var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPwCFunctIconsArrowIncreaseOutlineBlackRgb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104 99",
    style: {
      enableBackground: "new 0 0 104 99"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2D2D2D;}\n\t.st1{fill:#7D7D7D;}\n\t.st2{fill:#464646;}\n\t.st3{fill:#D04A02;}\n\t.st4{fill:#E0301E;}\n\t.st5{fill:#DB536A;}\n\t.st6{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Page-1_23_",
    d: "M19.8,84.8c-0.9,0.9-2.3,0.9-3.2,0c-0.9-0.9-0.9-2.3,0-3.2L80.3,18H27.3C26,18,25,17,25,15.7 c0-1.2,1-2.3,2.3-2.3H88v60.7c0,1.2-1,2.3-2.3,2.3s-2.3-1-2.3-2.3V21.2L19.8,84.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwCFunctIconsArrowIncreaseOutlineBlackRgb);
export default __webpack_public_path__ + "static/media/PwC_Funct_Icons_ArrowIncrease_Outline_Black_RGB.47401dbbb9041d531158c4f47dbee8c2.svg";
export { ForwardRef as ReactComponent };